import {API_URL} from 'api/constants'

/**
 * @return {string}
 */
export function OUTLET_BY_ID (outletId) { return (`${API_URL}/v1/outlets/${outletId}`) }

export const OUTLETS_SEARCH = `${API_URL}/v1/outlets/search`

export const OUTLET_NEW = `${API_URL}/v1/outlets/new`

export const UPDATE_SELECTED_OUTLET = `${API_URL}/v2/login/outlets`

export const OUTLETS_URL = `${API_URL}/v1/outlets`

export const OUTLET_PRICE = `${API_URL}/v1/billings/outlet_price`



// WEBPACK FOOTER //
// ./app/api/outlets/constants.js